<template>
  <hm-content title="复购分配客户" ref="hmcontent">
    <div class="bg-white ">
      <el-radio-group
        v-model="searchCondition.timeStatus"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label="my">我的客户</el-radio-button>
        <el-radio-button label="all">全部客户</el-radio-button>
      </el-radio-group>
    </div>
    <div class="bg-white">
      <div class="flex flex-between mb10">
        <el-radio-group
          v-model="searchCondition.followUpState"
          size="small"
          @change="switchTabs"
        >
          <el-radio-button label="waitFollowUp"
            >待跟进({{ waitFollowUpNum }})</el-radio-button
          >
          <el-radio-button label="yes"
            >已跟进({{ followUpNum }})</el-radio-button
          >
          <el-radio-button label="">全部({{ allMemberNum }})</el-radio-button>
        </el-radio-group>
        <div class="flex item-center">
          <span class="mr10" style="font-size:14px">导购信息</span>
          <el-select
            size="small"
            class="mr10"
            placeholder="是否有导购"
            clearable
            v-model="searchCondition.isHaveEmployee"
          >
            <el-option label="有导购" value="yes"></el-option>
            <el-option label="无导购" value="no"></el-option>
          </el-select>
          <el-select
            v-if="searchCondition.timeStatus === 'all'"
            size="small"
            clearable
            v-model="searchCondition.employeeId"
            filterable
            class="mr10"
            placeholder="请选择导购"
          >
            <el-option
              :label="item.realname"
              :value="item.employeeId"
              v-for="(item, index) in employeeIdAllList"
              :key="index"
            ></el-option>
          </el-select>
          <el-select
            size="small"
            clearable
            v-model="searchCondition.shopId"
            filterable
            class="mr10"
            style="width:200px"
            placeholder="选择最后一次消费门店"
          >
            <el-option
              :label="v.shopName"
              :value="v.shopId"
              v-for="(v, i) in allshopList"
              :key="i"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="flex flex-end item-center mb10">
        <span class="mr10" style="font-size:14px">复购时间</span>
        <el-date-picker
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          v-model="searchCondition.recommendRepurchaseTime"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
        <el-input
          clearable
          style="width:300px"
          v-model.trim="searchCondition.queryValue"
          placeholder="请输入"
          size="small"
          class="ipt mr10"
        >
          <el-select
            slot="prepend"
            size="small"
            style="width:100px"
            v-model="searchCondition.queryType"
          >
            <el-option label="客户姓名" value="memberName"></el-option>
            <el-option label="复购商品" value="goodsName"></el-option>
          </el-select>
        </el-input>
        <el-select
          filterable
          clearable
          size="small"
          class="mr10 "
          v-model="searchCondition.brandId"
          placeholder="请选择商品品牌"
        >
          <el-option
            :label="v.brandName"
            :value="v.brandId"
            v-for="(v, i) in allBrandList"
            :key="i"
          ></el-option>
        </el-select>
        <el-cascader
          v-model="searchCondition.categoryId"
          :show-all-levels="false"
          size="small"
          class="mr10"
          :props="categoryFunc"
          clearable
          placeholder="请选择类目"
        ></el-cascader>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button type="primary" size="small" @click="bacth"
          >批量分配导购</el-button
        >
        <el-button type="success" size="small" @click="output">导出</el-button>
      </div>
      <el-checkbox-group v-model="centerIds">
        <el-table
          border
          ref="table"
          :data="list"
          style="width: 100%"
          id="table"
          :header-cell-style="{ background: '#F7F7F7', color: '#606266' }"
          size="small"
          class="remind-plan"
        >
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column
            header-align="center"
            align="left"
            prop="rewardMode"
            label="客户信息"
            class-name="xxxx"
          >
            <template slot-scope="scope">
              <div class="border-b1 bg p10">
                <el-checkbox
                  :label="scope.row.centerId"
                  :disabled="scope.row.isHaveEmployee === 'yes'"
                >
                  <span v-show="false">{{ scope.row.centerId }}</span>
                </el-checkbox>
                <span class="mr20">
                  {{ scope.row.memberName }} 客户电话：{{
                    scope.row.memberMobile
                  }}
                </span>

                <span
                  v-for="(v, i) in scope.row.familyInfoVoList"
                  :key="i"
                  class="mr10"
                >
                  宝宝{{ i + 1 }}:
                  <span v-if="v.isPredicted === 'no'">
                    <span v-if="v.familyRelation === 'son'">男</span>
                    <span v-else-if="v.familyRelation === 'daughter'">女</span>
                  </span>
                  <span v-else>预产期</span>,{{ v.familyBirthdayStr }}({{
                    v.familyBirthday
                  }})
                </span>
              </div>
              <div
                class="border-b1 p20 flex item-center flex-between"
                v-for="(v, i) in scope.row.skuModelList"
                :key="i"
              >
                <div class="flex-1 flex">
                  <div class="mr10 flex item-center">
                    <el-image
                      style="width: 50px; height: 50px"
                      :src="v.spuMainPic"
                      :preview-src-list="[v.spuMainPic]"
                    >
                    </el-image>
                  </div>
                  <div style="white-space: nowrap">
                    <div>
                      {{ v.goodsName }}
                    </div>
                    <div>
                      <span class="orange mr20"
                        >{{ v.saleTime }}购买({{
                          moment().diff(v.saleTime, "days")
                        }}天前)
                      </span>
                      <span class="mr20">商品单价：¥{{ v.marketPrice }}</span>
                      <span class="mr20">商品数量：¥{{ v.goodsNumber }}</span>
                      <span class="mr20" v-if="v.saleAmount"
                        >实际付款：¥{{ v.saleAmount }}</span
                      >
                      <span class="mr20" v-else
                        ><el-tag size="small">赠品</el-tag></span
                      >
                    </div>
                  </div>
                </div>
                <div style="width:300px" class="flex flex-between">
                  <div class="orange mr20">
                    复购周期 {{ v.repurchaseCycleNum }} 天
                  </div>
                  <div>消费门店：{{ v.shopName }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="recommendRepurchaseTime"
            label="预计复购日期"
            width="100"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realname"
            width="100"
            label="导购"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.isHaveEmployee === 'yes'">
                {{ scope.row.realname }}
              </div>
              <el-button
                size="small"
                type="text"
                class="blue"
                v-else
                @click="getEmployee(scope.row)"
                >分配导购</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="followUpState"
            width="100"
            label="是否跟进"
          >
            <template slot-scope="scope">
              <div
                :class="scope.row.followUpState === 'yes' ? 'success' : 'gray'"
              >
                {{ scope.row.followUpState === "yes" ? "已跟进" : "未跟进" }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-checkbox-group>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="批量设置"
      width="80%"
      :visible.sync="dialogVisible"
    >
      <div class="table-panel flex flex-end">
        <div>
          <el-input
            clearable
            style="width:249px"
            size="small"
            type="text"
            placeholder="请输入导购账号/名称"
            class="mr10"
            v-model.trim="keyWords"
          ></el-input>
          <el-button type="primary" size="small" @click="searchGuider"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table mb10">
        <div class="tips mb20">提示：点击表格行即可选择</div>
        <el-table
          @current-change="getCheckedEmployee"
          :data="employeeList"
          highlight-current-row
          style="width: 100%"
          stripe
          size="small"
          border
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            label="用户账号"
            prop="username"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realname"
            label="用户名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="departName"
            label="所在门店"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="memberMobile"
            label="手机号"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.memberMobile">
                {{ scope.row.memberMobile }}
              </div>
              <div v-else>
                未绑定
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryLogo"
            label="状态"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.workingState == 'yes'" class="success"
                >在职</span
              >
              <span v-else class="danger">离职</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="employeeTotal"
          @current-change="pagingEmployee"
          @size-change="handleSizeChangeEmployee"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPageEmployee"
        ></el-pagination>
      </div>
      <div slot="footer" class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="keep">确 定</el-button>
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误
        </div>
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column
            header-align="center"
            align="center"
            prop="specBarcode"
            label="无效信息"
          >
            <template slot-scope="scope">
              {{ scope.row }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import moment from "moment";
// import { getDayAndToday } from "@/utils/utils";
export default {
  data() {
    return {
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      hidden: true,
      errValidGoods: false,
      errInputResult: [],
      moment,
      followUpNum: 0,
      allMemberNum: 0,
      waitFollowUpNum: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", date);
            }
          },
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "未来3天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
              picker.$emit("pick", date);
            }
          },
          {
            text: "未来7天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      searchCondition: {
        timeStatus: "all",
        followUpState: "",
        queryType: "memberName",
        recommendRepurchaseTime: ""
      },
      centerIds: [],
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      employeeIdAllList: [],
      allshopList: [],
      currentPageEmployee: 1,
      pageSizeEmployee: 10,
      employeeList: [],
      employeeTotal: 0,
      dialogVisible: false,
      keyWords: "",
      checkedEmployee: [],
      centerId: "",
      allBrandList: []
    };
  },
  created() {},
  mounted() {
    this.searchCondition.recommendRepurchaseTime = moment()
      .locale("zh-cn")
      .format("YYYY-MM-DD");

    this.queryAllEmployeeList();
    this.queryAllShopList();
    this.queryAllBrandList();
    this.queryEmployeeList();
    this.queryList();
  },
  methods: {
    async queryAllBrandList() {
      const { result } = await this.$store.dispatch("queryBrandAllList", {
        pageSize: 999999,
        pageNo: 1
      });
      this.allBrandList = result.records;
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async output() {
      if (this.searchCondition.recommendRepurchaseTime) {
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        await this.$store.dispatch(
          "repurchaseMemberSkuListExport",
          searchCondition
        );
        setTimeout(() => {
          this.$message({
            message: "已加入导出队列正在生成报表，请在导出列队中查看！",
            type: "success"
          });
          this.$refs.hmcontent.flag = false;
        }, 0);
      } else {
        this.$message({
          message: "请选择时间",
          type: "warning"
        });
      }
    },
    searchGuider() {
      this.currentEmployeePage = 1;
      this.queryEmployeeList();
    },
    async keep() {
      let params = {
        employeeId: this.checkedEmployee
      };
      if (this.centerId) {
        params.centerIds = [this.centerId];
      } else {
        params.centerIds = this.centerIds;
      }
      const { code, result } = await this.$store.dispatch(
        "assignEmployee",
        params
      );
      if (code == 0) {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.dialogVisible = false;
        this.queryList();
        this.centerId = "";
        this.centerIds = [];
        if (result.length) {
          this.errValidGoods = true;
          this.errInputResult = result;
        }
      }
    },
    bacth() {
      if (this.centerIds.length) {
        this.dialogVisible = true;
      } else {
        this.$message({
          message: "请选择导购",
          type: "warning"
        });
      }
    },
    getCheckedEmployee(selection) {
      this.checkedEmployee = selection.employeeId;
    },
    pagingEmployee(page) {
      this.currentPageEmployee = page;
      this.queryEmployeeList();
    },
    handleSizeChangeEmployee(size) {
      this.currentPageEmployee = 1;
      this.pageSizeEmployee = size;
      this.queryEmployeeList();
    },
    getEmployee(row) {
      this.dialogVisible = true;
      this.centerId = row.centerId;
      this.queryEmployeeList();
    },
    async queryEmployeeList() {
      const { result } = await this.$store.dispatch("queryEmployeeList", {
        pageNo: this.currentPageEmployee,
        pageSize: this.pageSizeEmployee,
        workingState: "yes",
        queryKey: this.keyWords,
        loginType: "store"
      });
      const { total, records } = result;
      this.employeeList = records;
      this.employeeTotal = total;
    },
    async queryList() {
      if (this.searchCondition.recommendRepurchaseTime) {
        let params = {
          pageSize: this.pageSize,
          pageNo: this.currentPage
        };

        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        searchCondition.categoryId = this.isArray(searchCondition.categoryId)
          ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
          : searchCondition.categoryId;
        Object.assign(params, searchCondition);

        const { code, result } = await this.$store.dispatch(
          "queryRepurchaseMemberInfoList",
          params
        );

        if (code === "0") {
          const {
            pageList,
            followUpNum,
            allMemberNum,
            waitFollowUpNum
          } = result;
          this.followUpNum = followUpNum;
          this.allMemberNum = allMemberNum;
          this.waitFollowUpNum = waitFollowUpNum;
          const { total, records } = pageList;
          this.list = records;
          this.total = total;
        }
      } else {
        this.$message({
          message: "请选择时间",
          type: "warning"
        });
      }
    },

    switchTab(val) {
      if (val === "my") {
        this.searchCondition.targetId = "";
      }
      this.currentPage = 1;
      this.queryList();
    },
    switchTabs() {
      this.currentPage = 1;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async queryAllShopList() {
      const { result } = await this.$store.dispatch("queryShopList", {
        pageNo: 1,
        pageSize: 99999
      });
      this.allshopList = result.records;
    },
    async queryAllEmployeeList() {
      let params = {
        pageNo: 1,
        pageSize: 9999,
        loginType: "store",
        workingState: "yes"
      };
      const { result } = await this.$store.dispatch("queryEmployee", params);
      this.employeeIdAllList = result.records;
    }
  }
};
</script>
<style lang="scss">
.remind-plan {
  .xxxx {
    padding: 0px;
    .cell {
      padding: 0px;
      margin-left: -10px;
    }
    .bg {
      background: #f7f7f7;
    }
  }
}
</style>
<style scoped lang="scss">
.border-b1 {
  border-bottom: 1px solid #ebeef5;
}
.bg-white {
  background: #fff;
  margin-bottom: 10px;
}
</style>
